var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToastClose = function SvgToastClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cbd0d6",
    d: "M.324 12.113a1.106 1.106 0 1 0 1.564 1.564l5.113-5.114 5.113 5.114a1.106 1.106 0 1 0 1.564-1.564L8.564 7l5.114-5.113A1.106 1.106 0 0 0 12.114.323L7.001 5.437 1.888.323A1.106 1.106 0 0 0 .324 1.887L5.438 7Z",
    "data-name": "Path 19170"
  })));
};
export default SvgToastClose;